export function getContactSchema({ url }) {
  if (url !== 'https://inspektlabs.com/contact-us') return null;

  return {
    '@context': 'https://schema.org',
    '@type': 'ContactPage',
    name: 'Contact Inspektlabs',
    url,
    description:
      'Contact Inspektlabs for AI-powered vehicle inspection and damage assessment solutions.',
    mainEntity: {
      '@id': 'https://inspektlabs.com/#organization',
    },
  };
}
